import type { CurationRun } from './types';

// The page polls a run started with "Rodar agora" / "Simular" until this holds.
export function isRunSettled(run: Pick<CurationRun, 'status'> | null | undefined): boolean {
  return !!run && run.status !== 'running';
}
